import i18n from 'i18next'; import { useContext } from 'react';
import PropTypes from 'prop-types';
import AuthContext from '../contexts/JWTContext';
import { Box, Typography } from '@material-ui/core';

const RoleGuard = (props) => {
  const { rules, children } = props;

  const auth = useContext(AuthContext);

  if (!rules) {
    return children;
  }

  if (rules && auth?.user?.permissions) {
    const hasPermission = rules(auth?.user?.permissions);
    if (hasPermission) {
      return children;
    }
  }
  return (
    <Box sx={{ top: '50%', left: '40%', position: 'absolute' }}>
      <Typography
        variant="body1"
        fontStyle="italic"
      >
        {i18n.t('RoleGuard.bu_sayfay\u0131_g\xF6r\xFCnt\xFClemeye_yetkiniz_bulunm')}

      </Typography>
    </Box>
  );
};

RoleGuard.propTypes = {
  rules: PropTypes.any,
  children: PropTypes.node
};

export default RoleGuard;
